import {
  Button,
  Image,
  Input,
  Switch,
  Table,
  Tooltip,
  Select,
  Modal,
  Form,
} from "antd";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import notfound from "../../assets/images/not_found.png";
import Plus from "../../assets/images/plus.svg";
import SectionWrapper from "../../components/SectionWrapper";
import apiPath from "../../constants/apiPath";
import { Severty, ShowToast } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import useRequest from "../../hooks/useRequest";
import AddForm from "./AddForm";
import { AppStateContext } from "../../context/AppContext";
import deleteWhiteIcon from "../../assets/images/icon/deleteWhiteIcon.png";
import DeleteModal from "../../components/DeleteModal";
import EditIcon from "../../assets/images/edit.svg";
import { DownloadExcel } from "../../components/ExcelFile";
import ShowVideoModal from "../../modals/ShowVideoModal";

function MediaContent() {
  const heading = "Content" + " " + "Management";
  const { setPageHeading, country } = useContext(AppStateContext);

  const sectionName = "Content";
  const routeName = "content";

  const api = {
    status: apiPath.contentMedia + "/status",
    addEdit: apiPath.contentMedia,
    list: apiPath.contentMedia,
  };

  const [searchText, setSearchText] = useState("");
  const { request } = useRequest();
  const [showMessage, setShowMessage] = useState(false);
  const [showStatusMessage, setShowStatusMessage] = useState(false);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [deleteModal, showDeleteModal] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [selected, setSelected] = useState();
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const debouncedSearchText = useDebounce(searchText, 300);
  const [exportLoading, setExportLoading] = useState(false);
  const [filter, setFilter] = useState({});

  const handleChangeStatus = (id) => {
    request({
      url: api.status + "/" + id,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        setRefresh((prev) => !prev);
        ShowToast(data.message, Severty.SUCCESS);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const onDelete = (id) => {
    request({
      url: api.addEdit + "/" + id,
      method: "DELETE",
      onSuccess: (data) => {
        setLoading(false);
        setRefresh((prev) => !prev);
        ShowToast(data.message, Severty.SUCCESS);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const columns = [
    {
      title: "src",
      dataIndex: "url",
      key: "url",
      render: (_, { url, type }) =>
        type === "Video" ? (
          <video
            className="table-img"
            width={50}
            src={url}
            onClick={() => {
              setSelected(url);
              setShowVideo(true);
            }}
          />
        ) : (
          <Image width={50} src={url ? url : notfound} className="table-img" />
        ),
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      sorter: (a, b) => a?.title?.localeCompare(b?.title),
      sortDirections: ["ascend", "descend"],
      render: (_, { title }) => {
        return title ? <span className="cap">{title}</span> : "-";
      },
    },
    {
      title: "Scheduler Time",
      key: "scheduler_time",
      dataIndex: "scheduler_time",

      render: (_, { scheduler_time }) => {
        return scheduler_time
          ? moment(scheduler_time).format("DD-MM-yyyy HH:mm")
          : "-";
      },
    },
    {
      title: "total liked count",
      key: "liked_by",
      dataIndex: "liked_by",
      sorter: (a, b) => (a?.liked_by?.length || 0) - (b?.liked_by?.length || 0),
      sortDirections: ["ascend", "descend"],
      render: (_, { liked_by }) => {
        return liked_by?.length ? liked_by?.length : "0";
      },
    },
    {
      title: "total watch count",
      key: "watch_count",
      dataIndex: "watch_count",
      sorter: (a, b) => (a?.watch_count || 0) - (b?.watch_count || 0),
      sortDirections: ["ascend", "descend"],
      render: (_, { watch_count }) => {
        return watch_count ? watch_count : "0";
      },
    },
    {
      title: "Is Publish",
      dataIndex: "is_uploaded",
      key: "is_uploaded",
      render: (_, { is_uploaded }) => {
        return is_uploaded ? (
          <span className="cap">{is_uploaded === true ? "Yes" : "No"}</span>
        ) : (
          "No"
        );
      },
    },

    {
      title: "Created On",
      key: "created_at",
      dataIndex: "created_at",

      render: (_, { created_at }) => {
        return moment(created_at).format("DD-MMM-YYYY");
      },
    },

    {
      title: "Status",
      key: "is_active",
      dataIndex: "is_active",
      filters: [
        {
          text: "Active",
          value: "true",
        },
        {
          text: "InActive",
          value: "false",
        },
      ],
      render: (_, { _id, is_active, have_active_item }) => {
        return (
          <Switch
            onChange={() => {
              if (have_active_item) {
                if (is_active) {
                  return setShowStatusMessage(true);
                } else {
                  return handleChangeStatus(_id);
                }
              }
              handleChangeStatus(_id);
            }}
            checked={is_active}
          />
        );
      },
    },
    {
      title: "Action",
      fixed: "right",
      key: "action",
      render: (_, record) => {
        return (
          <div div className="d-flex justify-contenbt-start">
            <Tooltip title={"Edit"} color={"purple"} key={"update" + routeName}>
              <Button
                title={"Edit"}
                className="edit-cls btnStyle primary_btn"
                onClick={() => {
                  setSelected(record);
                  setVisible(true);
                }}
              >
                <img src={EditIcon} />
                {/* <span>{"Edit"}</span> */}
              </Button>
            </Tooltip>

            <Tooltip title={"Delete"} color={"purple"} key={"Delete"}>
              <Button
                title={"Delete"}
                className="btnStyle deleteDangerbtn"
                onClick={() => {
                  if (record.have_item) {
                    return setShowMessage(true);
                  }
                  setSelected(record);
                  showDeleteModal(true);
                }}
              >
                <img src={deleteWhiteIcon} />
                {/* <span>{"Delete"}</span> */}
              </Button>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    setLoading(true);
    fetchData(pagination);
  }, [refresh, debouncedSearchText, country.country_id, filter]);

  useEffect(() => {
    setPageHeading(heading);
  }, [setPageHeading]);

  const fetchData = (pagination, filters, sorter) => {
    const filterActive = filters ? filters.is_active : null;
    const queryString = Object.entries(filter)
      .filter(([_, v]) => v != undefined)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    request({
      url:
        api.list +
        `?type=Video&status=${
          filterActive ? filterActive.join(",") : ""
        }&page=${
          pagination ? (debouncedSearchText ? 1 : pagination.current) : 1
        }&limit=${
          pagination ? pagination.pageSize : 10
        }&search=${debouncedSearchText}${queryString ? `&${queryString}` : ""}`,
      method: "GET",
      onSuccess: ({ data }) => {
        setLoading(false);
        setList(() => {
          return data.docs.map((item) => {
            return {
              ...item,
              key: item._id,
            };
          });
        });
        setPagination((prev) => ({
          ...prev,
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: data.totalDocs,
        }));
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);

        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChange = (pagination, filters, sorter) => {
    const { field, order } = sorter;
    let query = undefined;
    if (field && order) {
      query = `${field}=${order}`;
      console.log(query);
    }
    fetchData(pagination, filters, query);
  };

  const onSearch = (e) => {
    setSearchText(e.target.value);
  };

  const getExportData = async () => {
    try {
      const queryString = Object.entries(filter)
        .filter(([_, v]) => v != undefined)
        .map(
          ([key, value]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join("&");
      setExportLoading(true);
      request({
        url:
          api.list +
          `?type=video&page=${pagination ? pagination.current : 1}&limit=${
            pagination?.total ? pagination?.total : 1000
          }&search=${debouncedSearchText}${
            queryString ? `&${queryString}` : ""
          }`,
        method: "GET",
        onSuccess: ({ data, status, total, message }) => {
          setExportLoading(false);
          if (status) {
            excelData(data.docs ?? []);
          }
        },
        onError: (error) => {
          console.log(error);
          setExportLoading(false);
          ShowToast(error, Severty.ERROR);
        },
      });
    } catch (err) {
      console.log(err);
      setExportLoading(false);
    }
  };

  const excelData = (exportData) => {
    if (!exportData.length) return;

    const data = exportData.map((row) => ({
      Title: row?.title || "-",
      Url: row.url ? row.url : "-",
      "Scheduler Time": moment(row?.scheduler_time).format("DD-MM-yyyy HH:mm"),
      "Registered On": moment(row?.created_at).format("DD-MM-YYYY"),
    }));
    DownloadExcel(data, sectionName);
  };

  return (
    <>
      <SectionWrapper
        cardHeading={`All Videos`}
        extra={
          <>
            {/* <div className="button_group justify-content-end w-100"> */}
            <div className="w-100 text-head_right_cont">
              <div className="pageHeadingSearch">
                <Input.Search
                  className="searchInput"
                  placeholder={"Search by Content title"}
                  onChange={onSearch}
                  allowClear
                />
              </div>

              {/* <div className="btn_grp">
                <Button
                  loading={exportLoading}
                  onClick={() => getExportData()}
                  className="primary_btn btnStyle"
                >
                  {"Export to Excel"}
                </Button>
              </div> */}
              <Button
                className="primary_btn btnStyle"
                onClick={(e) => {
                  setVisible(true);
                  setSearchText("");
                }}
              >
                <span className="add-Ic">
                  <img src={Plus} />
                </span>
                {"Add New "}
                {sectionName}
              </Button>
            </div>
          </>
        }
      >
        <div className="table-responsive customPagination checkBoxSrNo">
          <Table
            loading={loading}
            columns={columns}
            dataSource={list}
            pagination={{
              current: pagination?.current,
              defaultPageSize: 10,
              responsive: true,
              total: pagination.total,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ["10", "20", "30", "50"],
            }}
            onChange={handleChange}
            className="ant-border-space"
          />
        </div>
      </SectionWrapper>

      {visible && (
        <AddForm
          section={sectionName}
          api={api}
          show={visible}
          contentType={"Video"}
          hide={() => {
            setSelected();
            setVisible(false);
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      {deleteModal && (
        <DeleteModal
          reasons={[]}
          title={"Delete Content"}
          subtitle={`Are you sure you want to Delete this Content?`}
          show={deleteModal}
          hide={() => {
            showDeleteModal(false);
            setSelected();
          }}
          onOk={() => onDelete(selected?._id)}
        />
      )}

      {showVideo && (
        <ShowVideoModal
          show={showVideo}
          hide={() => {
            setShowVideo(false);
            setSelected();
          }}
          data={selected}
          onOk={() => {
            setShowVideo(false);
            setSelected();
          }}
        />
      )}
    </>
  );
}



export default MediaContent;
